<!-- Экран записи на тестирование -->
<template>
    <div>
        <div class="white_container info_lesson_container">
            <div class="tiny-booking-wrapper">
                <div class="tiny-booking-header">
                    <h4>{{$t("lesson.LBL_TRIAL_VIDEOCALL_PREHEADER")}}</h4>
                    <h2>{{$t("lesson.LBL_TRIAL_VIDEOCALL_HEADER")}}</h2>
                </div>
                <div class="tiny-booking-actions">
                    <p v-if="isTrialSoonLesson==true" v-html="$t('lesson.LBL_TRIAL_COMMING_SOON_HELPER',{
                        date:trialTextDate,
                        time:trialTextTime
                    })"></p>
                    <p v-if="isTrialSoonLesson==false" v-html="$t('lesson.LBL_TRIAL_COMMING_SOON_HELPER',{
                        date:trialTextDate,
                        time:trialTextTime
                    })"></p>
                    <a v-if="isTrialSoonLesson==true" :href="trial.link" target="_blank" class="button with_icon"><i class="icon-play-circle"></i><span>{{$t("lesson.BTN_START_TRIAL_TRANSLATION")}}</span></a>
                    <button v-if="isTrialSoonLesson==false" class="button button_not_active"><span>{{$t("lesson.BTN_TRIAL_VIDEOCALL_SOON")}}</span></button>
                </div>
            </div>
        </div>
        <div class="white_container info_lesson_container">
            <h2 class="reserve_lesson_header">{{$t("lesson.LBL_TECH_BOOK_HEADER")}}</h2>
            <p class="text" v-html="$t('lesson.LBL_TECH_BOOK_DESCRIPTION')"></p>
            <div class="wrapp_descriptions">
                <div class="description">
                    <img src="/images/icon.png">
                    <div class="description_text_wrap">
                        <span class="description_text_number">01</span>
                        <span class="description_text" v-html="$t('lesson.LBL_TECH_BOOK_DESCRIPTION_STEP1')"></span>
                    </div>
                </div>
                <div class="description">
                    <img src="/images/icon1.png">
                    <div class="description_text_wrap">
                        <span class="description_text_number">02</span>
                        <span class="description_text" v-html="$t('lesson.LBL_TECH_BOOK_DESCRIPTION_STEP2')"></span>
                    </div>
                </div>
                <div class="description">
                    <img src="/images/icon2.png">
                    <div class="description_text_wrap">
                        <span class="description_text_number">03</span>
                        <span class="description_text" v-html="$t('lesson.LBL_TECH_BOOK_DESCRIPTION_STEP3')"></span>
                    </div>
                </div>
                <div class="description">
                    <img src="/images/icon3.png">
                    <div class="description_text_wrap">
                        <span class="description_text_number">04</span>
                        <span class="description_text" v-html="$t('lesson.LBL_TECH_BOOK_DESCRIPTION_STEP4')"></span>
                    </div>
                </div>
            </div>
            <div class="checkbox_wrapp">
                <label class="container">{{$t("lesson.LBL_TECHNICAL_LABEL_CONFIRM")}}<input type="checkbox" v-model="checked"><span class="checkmark"></span></label>
            </div>
        </div>
        <div class="white_container reserve_lesson_container" v-if="checked">
            <h2 class="reserve_lesson_header">{{$t("lesson.LBL_TECH_LESSON_TITLE")}}</h2>
            <div class="reserve_lesson_body">
                <div class="calendar_wrapper">
                    <span class="calendar_text">{{$t("lesson.LBL_TECH_LESSON_DATES_SELECT")}}</span>
                    <TehBookingCalendarSchedule v-on:selectedDateEvent="selectedDateEvent"/>
                </div>
                <div class="day_schedule">
                    <span class="day_schedule_text">{{$t("lesson.LBL_TECH_LESSON_SELECT_HELPER")}} <span style="text-transform: uppercase">{{selectedDateConvert}}</span> </span>
                    <TehBookingDaySchedule :initialDate="selectedDate" :correct_date="date_valid" v-on:selectedHourEvent="selectedHourEvent"/>
                </div>
            </div>
            <div class="reserve_lesson_footer">
                <button :disabled="selectedHour == null" class="button" @click="lessonBookingEvent">
                <span>{{$t("strings.BTN_CONFIRM")}}</span>
                </button>
            </div>
        </div>
        <TehBookingErrorPopup
        :show="booking_error"
        v-on:closeEvent="TehBookingErrorPopupCloseEvent"
        ></TehBookingErrorPopup>
    </div>
</template>

<script>
    import TehBookingCalendarSchedule from './TehBookingCalendarSchedule'
    import TehBookingDaySchedule from './TehBookingDaySchedule'
    import {todayHowString,rest} from '@/utils/utils';
    import axios from 'axios'
    import env from '@/enviroment';
    import lStorage from '@/store/localStorage';
    import store from '@/store';
    import { dateConvert, MONTH_NAMES } from '../../../../../utils/utils';
    import { mapGetters, mapActions } from 'vuex';
    import TehBookingErrorPopup from './popups/TehBookingErrorPopup';

    export default {
        name: 'TehBookingStep',
        components: {
            TehBookingCalendarSchedule,
            TehBookingDaySchedule,
            TehBookingErrorPopup
        },
        data: function () {
            return {
                // lessonStatus: 0,
                selectedDate: todayHowString(),
                selectedHour: null,
                checked: false,
                content: {},
                booking_error:false,
                date_valid:true,
                trial:{},
                trialTick:null,
                isTrialSoonLesson:false
            }
        },
        computed: {
            ...mapGetters({
                lessonStatus: 'user/studentStatus',
            }),
            selectedDateConvert() {
                return dateConvert(this.selectedDate)
            },
            selectedHourStart() {
                if (this.selectedHour == null) {
                return '';
                }
                return this.selectedHour.start;
            },
            trialTextTime(){
                if(typeof this.trial.datetime != "undefined" && this.trial.datetime !== null && this.trial.datetime !== '') {
                    return this.trial.datetime.split(' ')[1];
                }
                return '';
            },
            trialTextDate(){
                if (typeof this.trial.datetime != "undefined" && this.trial.datetime !== '' && this.trial.datetime !== null) {
                    let date = this.trial.datetime.split(' ')[0];
                    return dateConvert(date);
                }
                return '';
            },
        },
        methods: {
            selectedDateEvent(date,valid=true){
                this.date_valid = valid;
                this.selectedHour = null;
                this.selectedDate = date;
            },
            selectedHourEvent(hour) {
                this.selectedHour = hour;
            },
            lessonBookingEvent() {
                this.lessonBooking({
                    hourId: this.selectedHour.id,
                    date: this.selectedDate
                })
            },
            nextStep() {
                store.commit('trialBookingFlow/currentStep', 'tech-booked');
                store.dispatch('trialBookingFlow/getHomeInfo');
            },
            lessonBooking(lesson) {
                store.commit('loading/is', true);
                rest.call("lesson_booking",{
                    "id":lesson.hourId,
                    "phone":lesson.phone,
                    "date":lesson.date
                },"POST").then((response)=>{
                    store.commit('loading/is',false);
                    if(response.status == "ok"){
                        this.nextStep();
                    }else{
                        this.selectedHour = null;
                        this.selectedDate = todayHowString();
                        this.showTrialBookingErrorPopup = true;
                    }
                }).catch((error)=>{
                    store.commit('loading/is', false);
                    //Произошла ошибка во время записи - выведем сообщение
                    this.booking_error = true;
                    this.selectedHour = null;
                    this.selectedDate = todayHowString();
                    this.showTrialBookingErrorPopup = true;
                });
                /*
                axios.post(env.URL + '/wp-json/sahapi/v1/tech_check_booking', {
                id: lesson.hourId,
                date: lesson.date,
                }, {
                headers: {
                    'Authorization': 'Bearer ' + lStorage.get('auth-token'),
                }
                })
                .then((response) => {
                    let data = response.data;
                    store.commit('loading/is', false);
                    if (data.success) {
                    this.nextStep();
                    } else {
                    this.selectedHour = null;
                    this.selectedDate = todayHowString();
                    this.showTrialBookingErrorPopup = true;
                    }
                })
                .catch((error) => {
                    this.booking_error = true;
                    store.commit('loading/is', false);
                    this.selectedHour = null;
                    this.selectedDate = todayHowString();
                    this.showTrialBookingErrorPopup = true;
                    console.log('tech_check_booking', error)
                });
                */
            },
            TehBookingErrorPopupCloseEvent(){
                this.booking_error=false;
            },
            getDiffInSeconds(date){
                let now = new Date();
                let datet = new Date(date);
                let diff = datet - now;
                return Math.round(diff / 1000); // преобразуем в секунды
            },
            trialTickOut(){
                if(typeof this.trial.datetime != "undefined" && this.trial.datetime !== null && this.trial.datetime !== '') {
                    var d = this.getDiffInSeconds(new Date(this.trial.datetime));
                    if(d <= 900){
                        this.isTrialSoonLesson = true;
                        window.clearInterval(this.trialTick);
                        return true;
                    }
                }
                this.isTrialSoonLesson = false;
            }
        },
        mounted(){
            store.commit('loading/is', true);
            rest.call("lead_status",{},"POST").then((response)=>{
                store.commit('loading/is',false);
                if(response.status == "ok" && response.data){
                    this.trial = response.data.trial;
                    this.trialTickOut();
                    this.trialTick = window.setInterval(this.trialTickOut,1000*60);
                }
            }).catch((error)=>{
                store.commit('loading/is',false);
            });
        }
    }
</script>

<style lang="scss" scoped>
    .checkbox_wrapp {
        display: flex;
        justify-content: flex-start;
        width: 50%;
        margin-left: auto;
        padding-left: 35px;
        margin-top: 36px;
    }

    /* Customize the label (the container) */
    .container {
        display: block;
        position: relative;
        padding-left: 35px;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;

        font-family: FuturaPT;
        font-size: 16px;
        letter-spacing: 0.5px;
        color: #CF0920;
    }

    /* Hide the browser's default checkbox */
    .container input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }

    /* Create a custom checkbox */
    .checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 21px;
        width: 21px;
        border: 2px solid #CF0920;
        border-radius: 2px;
    }

    /* On mouse-over, add a grey background color */
    .container:hover input ~ .checkmark {
        border: 2px solid #CF0920;
        border-radius: 2px;
    }

    /* When the checkbox is checked, add a blue background */
    .container input:checked ~ .checkmark {
        background-color: #CF0920;
    }

    /* Create the checkmark/indicator (hidden when not checked) */
    .checkmark:after {
        content: "";
        position: absolute;
        display: none;
    }

    /* Show the checkmark when checked */
    .container input:checked ~ .checkmark:after {
        display: block;
    }

    /* Style the checkmark/indicator */
    .container .checkmark:after {
        left: 5px;
        top: 1px;
        width: 5px;
        height: 10px;
        border: solid white;
        border-width: 0 3px 3px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
    }

    .info_lesson_container {
        padding: 2.3rem 3.3rem;
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        margin-bottom: 2.3rem;
        .wrapp_descriptions {
            display: flex;
            flex-wrap: wrap;
            margin-top: 1.6rem;
            .description {
                display: flex;
                align-items: center;
                width: 50%;
                margin-top: 1.6rem;
                padding-right: 1rem;
                img {
                    width: 80px;
                    height: auto;
                    background: #E9ECF1;
                    border-radius: 100rem;
                    margin-right: 2.4rem;
                }
                .description_text_wrap {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    .description_text_number {
                        font-family: FuturaPT;
                        font-size: 16px;
                        line-height: 20px;
                        letter-spacing: 0.5px;
                        color: rgba(11, 16, 34, 0.3);
                    }
                    .description_text {
                        font-family: FuturaPT;
                        font-size: 16px;
                        line-height: 20px;
                        letter-spacing: 0.5px;
                        color: #0B1022;
                    }
                }
            }
        }
    }

    .reserve_lesson_container {
        padding: 30px 44px;
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        margin-bottom: 2.3rem;
    }

    .reserve_lesson_body {
        display: flex;
        min-height: 35rem;
    }

    .calendar_wrapper {
        margin-right: 6rem;
    }

    .calendar_text, .day_schedule_text {
        font-family: FuturaPT;
        font-size: 16px;
        line-height: 20px;
        letter-spacing: 0.5px;
        color: rgba(11, 16, 34, 0.3);
        margin-bottom: 2.5rem;
        display: inline-block;
    }

    .reserve_lesson_footer {
        width: 100%;
        display: flex;
        margin-top: 17px;
        margin-bottom: 12px;

        .button {
        margin-left: auto;
        padding: 0.75rem 2.5rem 1rem 2.5rem;
        }
    }

    .component-fade-enter-active, .component-fade-leave-active {
        transition: opacity .2s ease;
    }

    .component-fade-enter, .component-fade-leave-to
        /* .component-fade-leave-active below version 2.1.8 */
    {
        opacity: 0;
    }
    .tiny-booking-wrapper{
        display: flex;
        width: 100%;
        flex-direction: row;
        .tiny-booking-header{
            width: 100%;
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
        }
        .tiny-booking-actions{
            > p{
                margin-bottom: 15px;
            }
        }
    }
    .button.button_not_active{
        background: #f0f3f8;
        color: #0B1022;
        -webkit-box-shadow: none;
        box-shadow: none;
        cursor: default;
    }
</style>
